module.exports = __webpack_public_path__ + "img/510.general.e9c93e0e.svg";